module.exports = __webpack_public_path__ + "img/1280x720-Summer.f5335492.jpg";